module.exports = __webpack_public_path__ + "a8a10a3e/img/arrow-share-icon.00a12c29.svg";